import React, {PropTypes} from 'react';
import _ from 'lodash';


const dropDownCustomization = {
  labelStyle: {
    padding: 0,
    margin: 0
  },
  underlineStyle: {
    marginLeft: 0
  },
  floatingLabelStyle: {
    left: 0,
    top: '-3px'
  },
  containerStyle: {
    width: '40%',
    margin: '30px 0 10px 45px'
  }
};

export default function StatusDetermination() {

  return (
    <div className='expanded-accordion-content explanation-of-wahve'>
      <div className='callout'>
        During or at the end of the interview, you will need to decide the status of the applicant. Based on that determination, when you click on the appropriate status, a closing script will appear for you to conclude the interview.
      </div>
      <div className='callout'>
        <b>Active</b> - Applicant Qualified
      </div>
      <div className='callout'>
        If the applicant scored acceptable or better on assessments, application is complete, and interview was satisfactory, and the applicant is determined to be qualified (an overall rating of 3 or better), select the “Active” status.
      </div>
      <div className='callout'>
        The applicant will receive an email which you can edit and the applicant’s records will be exported to Bullhorn. The applicant’s record is moved to the Standby Applicants pipeline.
      </div>
      <div className='callout'>
        If the applicant’s availability date is between 45 days and 4 months, the record will not export to Bullhorn. Forty-four days prior to the availability date, the record will automatically export.
      </div>
      <div className='callout'>
        Active applicants are placed in the Standby pipeline waiting to be matched to an assignment in Bullhorn.
      </div>
      <div className='callout'>
        <b>Not Qualified</b>
      </div>
      <div className='callout'>
        If the applicant is technically qualified but of low caliber or not qualified at all, do not approve (overall rating 2 or below). If you feel the applicant may have a potential character issue, do not approve. Explain in the notes the reason for your decision. In both instances, change the status to Not Qualified.
      </div>
      <div className='callout'>
        The applicant is not sent an email. The applicant’s record is moved to the Not Qualified Applicants pipeline. Not Qualified applicants are moved to the Inactive pipeline.
      </div>
      <div className='callout'>
        <b>Pending information Update</b>
      </div>
      <div className='callout'>
        If the applicant needs to correct her/his application:
      </div>
      <div className='callout'>
        <ul className='instructions-list'>
          <li className='instructions-list-item'>Change the applicant’s status to Pending Information Update.</li>
          <li className='instructions-list-item'>When the applicant updates her/his information, you will receive a notification.</li>
          <li className='instructions-list-item'>Call the applicant and complete the application review and interview.</li>
          <li className='instructions-list-item'>If update acceptable, change the Status to Active.</li>
        </ul>
      </div>
      <div className='callout'>
        <b>Applicant in Waiting</b>
      </div>
      <div className='callout'>
        If the Applicant is Qualified but when reviewing the availability date, the applicant changes it to greater than four months, immediately conclude the interview and:
      </div>
      <div className='callout'>
        <ul className='instructions-list'>
          <li className='instructions-list-item'>Change her/his availability date to the new date.</li>
          <li className='instructions-list-item'>Change the applicant status to “Applicant in Waiting.”</li>
          <li className='instructions-list-item'>A script will guide you through the conclusion.</li>
          <li className='instructions-list-item'>At the four month mark, the applicant will be invited back to update the application.</li>
          <li className='instructions-list-item'>The applicant will be moved to the Standby pipeline. At the four month mark, the applicant will be moved back to the In Progress Pipeline, Pending Application.</li>
          <li className='instructions-list-item'>The applicant will receive an email inviting her/him to update the application and that you will call to discuss the next steps</li>
          <li className='instructions-list-item'>You will also receive a notification that the applicant is now available for you to complete the interview process.</li>
        </ul>
      </div>
      <div className='callout'>
        It is essential that throughout the interview, you summarize the conversation and add any comments that will give the placement specialist a better understanding of the applicant.
      </div>
    </div>
  );

}

StatusDetermination.propTypes = {
  staticData: PropTypes.object,
  script: PropTypes.bool,
  applicant: PropTypes.object,
  updateTempState: PropTypes.func,
  model: PropTypes.string.isRequired,
  tempState: PropTypes.object
};



// WEBPACK FOOTER //
// ./shared/react/r_ExpandedCard/Steps/Interview/f_StatusDetermination/index.js